import './RadioGroup.scss';
import { TRadioGroupProps } from './RadioGroup.type';

const RadioGroup: React.FC<TRadioGroupProps> = (props: TRadioGroupProps) => {
  const {
    items,
    userSelectedValue,
    defaultValue,
    handleChange,
    type,
    slug,
    validationError = false,
  } = props;

  return (
    <div className="Radio_Group">
      {items?.map((option: any) => (
        <label key={option?.OPTION_VALUE} className="Radio_Option">
          <input
            type="radio"
            name={option?.OPTION_VALUE}
            value={option?.OPTION_VALUE}
            checked={option?.OPTION_VALUE === (userSelectedValue || defaultValue)}
            className={`radio-input ${option?.OPTION_VALUE === (userSelectedValue || defaultValue) ? 'checked' : ''}`}
            onChange={() => handleChange(type, slug, option?.OPTION_VALUE)}
          />
          <p className="ml-1">{option?.OPTION_TITLE}</p>
        </label>
      ))}
    </div>
  );
};

export default RadioGroup;
